import { DrawerProps, Drawer as MaterialDrawer } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

interface Props extends DrawerProps {
  open: boolean;
  onClose: () => void;
}

const StyledMaterialDrawer = styled(MaterialDrawer)`
  .MuiDrawer-paper {
    background-color: rgba(37, 37, 37, 1) !important;
    background-image: none;
  }
`;

const Content = styled.div`
  padding: 3rem;
  height: 100%;
  overflow: hidden;
`;

const Drawer: React.FC<React.PropsWithChildren<Props>> = ({ children, ...rest }) => {
  return (
    <StyledMaterialDrawer
      PaperProps={{
        elevation: 3
      }}
      {...rest}
      anchor="right"
    >
      <Content>{children}</Content>
    </StyledMaterialDrawer>
  );
};
export default Drawer;
